import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: '¿Qué garantía tiene el servicio?',
  answer: 'Ofrecemos una garantía de reposición. Si el candidato seleccionado se desvincula de la empresa durante el período de prueba acordado, reiniciamos el proceso de búsqueda para esa misma posición sin costo adicional.'
}, {
  question: '¿Cuánto demora un proceso de selección?',
  answer: 'El tiempo varía según la complejidad del perfil, pero nuestros procesos están diseñados para presentar candidatos finalistas de forma ágil.'
}, {
  question: '¿En qué se diferencian de un portal de empleos?',
  answer: 'Nosotros no solo publicamos un aviso. Realizamos un filtro exhaustivo, entrevistas por competencias, verificamos referencias y evaluamos el ajuste cultural, presentando finalistas que se amoldan al perfil.'
}, {
  question: '¿Realizan búsquedas en todo el país?',
  answer: 'Con nuestras bases en Buenos Aires y Córdoba, gestionamos procesos de selección y hunting en todo el territorio argentino.'
}, {
  question: '¿Qué costo tiene el servicio?',
  answer: 'Nuestros honorarios se calculan en base a la complejidad del perfil. Contactanos para una cotización personalizada.'
}];
export function FAQ() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section ref={ref} className="py-24 px-6 bg-white" data-id="element-80">
      <div className="max-w-4xl mx-auto" data-id="element-81">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-82">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4" data-id="element-83">
            Preguntas Frecuentes
          </h2>
          <p className="text-xl text-slate-600" data-id="element-84">Resolvemos tus dudas</p>
        </motion.div>

        <div className="space-y-4" data-id="element-85">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="bg-slate-50 rounded-xl overflow-hidden" data-id="element-86">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-8 py-6 flex items-center justify-between text-left hover:bg-slate-100 transition-colors" data-id="element-87">
                <span className="text-lg font-semibold text-slate-900 pr-8" data-id="element-88">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-6 h-6 text-emerald-600 flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-89" />
              </button>
              <motion.div initial={false} animate={{
            height: openIndex === index ? 'auto' : 0,
            opacity: openIndex === index ? 1 : 0
          }} transition={{
            duration: 0.3,
            ease: 'easeInOut'
          }} className="overflow-hidden" data-id="element-90">
                <div className="px-8 pb-6 text-slate-600 leading-relaxed" data-id="element-91">
                  {faq.answer}
                </div>
              </motion.div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}